import * as React from 'react';

import { VideoReviewCard } from './components/VideoReviewCard';
import { CarouselFullscreen } from '../../../../CarouselFullscreen';

import videoReviewsData from './videoReviews.json';

import * as main from '../../styles/main.module.scss';
import * as style from './videoReviews.module.scss';
import { opacity100 } from './videoReviews.module.scss';

import useMediaQuery from '@mui/material/useMediaQuery';

export const VideoReviewsWithCards = ({ data=videoReviewsData, title, titleCenter=false }) => {

  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });

  const [slideNextDisabled, setSlideNextDisabled] = React.useState(false);
  const [slidePrevDisabled, setSlidePrevDisabled] = React.useState(false);

  const isMobile = useMediaQuery('(max-width:767px)');
  const updatePosition = () => {
    if (swiperEl.current) {
      setSlideNextDisabled(swiperEl.current?.swiper.isEnd);
      setSlidePrevDisabled(swiperEl.current?.swiper.isBeginning);
    }
  };
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 2,
        spaceBetween: 5,
        loop: true,
        centeredSlides: true,
        watchSlidesProgress: true,
        slideVisibleClass: opacity100,
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 20,
          },

          1023: {

            slidesPerView: 2,
            spaceBetween: 30,
          },
        },
        pagination: {
          type: isMobile ? false : "fraction",
        }
      });
      swiperEl.current.initialize();
      updatePosition();
    }
  }, [isMobile]);
  swiperEl.current?.addEventListener('reachbeginning', updatePosition);
  swiperEl.current?.addEventListener('reachend', updatePosition);
  swiperEl.current?.addEventListener('resize', updatePosition);
  return (
    <section className={style.videoReviews} id={"video-reviews"}>
      <div className="container">
        <h2 className={main.mainTitle} style={{ textAlign: titleCenter ? "center" : "left" }}>
          { title || "Почему выбирают Advance" }
        </h2>
        <swiper-container ref={swiperEl} class={style.mySwiper} init="false">
          {data.map((elem, index) => (
            <swiper-slide key={index}>
              <button
                onClick={() => {
                  setFullScreenState({ open: true, selectedSlideIndex: index });
                }}
              >
              <VideoReviewCard data={elem} />
              </button>
            </swiper-slide>
          ))}
        </swiper-container>
        <button
          aria-label="swiper-button-next"
          className={`${style.swiperButtonNext} ${slidePrevDisabled && `${style.swiperButtonDisabled}`}`}
          onClick={() => {
            swiperEl.current.swiper.slidePrev();
          }}
        />
        <button
          aria-label="swiper-button-prev"
          className={`${style.swiperButtonPrev} ${slideNextDisabled && `${style.swiperButtonDisabled}`}`}
          onClick={() => {
            swiperEl.current.swiper.slideNext();
          }}
        />
      </div>
      <CarouselFullscreen
        data={data.map((elem) => (
          <div className={style.videoReviews__videoBlock}>
            <div className={style.videoReviews__videoWrapper}>
              <iframe
                title={elem.id}
                allow="autoplay; encrypted-media"
                src={elem.video}
                className={style.videoReviews__videoFrame}
                allowFullScreen
              />
            </div>
          </div>
        ))}
        open={fullScreenState.open}
        selectedSlideIndex={fullScreenState.selectedSlideIndex}
        onClose={() => {
          setFullScreenState({ open: false, selectedSlideIndex: 0 });
        }}
      />
    </section>
  );
};
